module.exports = __webpack_public_path__ + "img/1131884875.24f62744.jpg";